import {
  PERITADOR_ACT_DIALOG_GENERATE_STEPS,
  PERITADOR_ACT_DIALOG_UPDATE_CLIENT,
  PERITADOR_ACT_DIALOG_UPDATE_SERVICE,
  PERITADOR_ACT_DIALOG_FINISH_STEPS,
  PERITADOR_ACT_DIALOG_ACTIVE_STEP,
  PERITADOR_ACT_DIALOG_CLOSE
} from './constants'
import {
  REQUEST_DIALOG_STEP_TYPES,
  INITIAL_STEP_ORDER_VALUE
} from '../crud-dialog/RequestDialog.constants'

export function actNextDialogStep() {
  return (dispatch, getState) => {
    const { peritador } = getState()
    const { requestDialogSteps = [], requestDialogCurrentStep = {} } = peritador

    const nextStepIndex = requestDialogCurrentStep?.order + 1

    if (nextStepIndex >= requestDialogSteps.length) {
      dispatch({
        type: PERITADOR_ACT_DIALOG_FINISH_STEPS
      })
    } else {
      dispatch({
        type: PERITADOR_ACT_DIALOG_ACTIVE_STEP,
        data: requestDialogSteps[nextStepIndex]
      })
    }
  }
}

export function actPrevDialogStep() {
  return (dispatch, getState) => {
    const { peritador } = getState()
    const { requestDialogSteps = [], requestDialogCurrentStep = {} } = peritador

    if (requestDialogCurrentStep.order > 0) {
      const prevStepIndex = requestDialogCurrentStep.order - 1
      dispatch({
        type: PERITADOR_ACT_DIALOG_ACTIVE_STEP,
        data: requestDialogSteps[prevStepIndex]
      })
    }
  }
}

export function actGenerateSteps() {
  return dispatch => {
    // INITIAL VALUES
    let steps = []
    let order = INITIAL_STEP_ORDER_VALUE

    // CLIENT STEP
    const clienteStep = _createStep(
      'Datos del cliente',
      REQUEST_DIALOG_STEP_TYPES.CLIENTE,
      order
    )
    steps.push(clienteStep)
    order += 1

    // SERVICE STEP
    const serviceStep = _createStep(
      'Datos del servicio',
      REQUEST_DIALOG_STEP_TYPES.SERVICIO,
      order
    )
    steps.push(serviceStep)

    dispatch({
      type: PERITADOR_ACT_DIALOG_GENERATE_STEPS,
      data: steps
    })
  }
}

function _createStep(label, type, order) {
  const canGoBack = order > INITIAL_STEP_ORDER_VALUE
  return {
    label,
    type,
    order,
    canGoBack
  }
}

export function actUpdateRequestDialogClient(client) {
  return dispatch => {
    dispatch({
      type: PERITADOR_ACT_DIALOG_UPDATE_CLIENT,
      data: client
    })
  }
}

export function actUpdateRequestDialogService(service) {
  return dispatch => {
    dispatch({
      type: PERITADOR_ACT_DIALOG_UPDATE_SERVICE,
      data: service
    })
  }
}

export function actCloseRequestDialog() {
  return dispatch => {
    dispatch({
      type: PERITADOR_ACT_DIALOG_CLOSE
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_DIALOG_GENERATE_STEPS:
      return {
        ...state,
        requestDialogSteps: action.data,
        requestDialogCurrentStep: action.data[0],
        actPostRequestsSuccess: false,
        requestDialogAllStepsCompleted: false,
      }
    case PERITADOR_ACT_DIALOG_ACTIVE_STEP:
      return {
        ...state,
        requestDialogCurrentStep: action.data
      }
    case PERITADOR_ACT_DIALOG_FINISH_STEPS:
      return {
        ...state,
        requestDialogCurrentStep: null,
        requestDialogAllStepsCompleted: true
      }
    case PERITADOR_ACT_DIALOG_UPDATE_CLIENT:
      return {
        ...state,
        requestDialogClient: action.data
      }
    case PERITADOR_ACT_DIALOG_UPDATE_SERVICE:
      return {
        ...state,
        requestDialogService: action.data
      }
    case PERITADOR_ACT_DIALOG_CLOSE:
      return {
        ...state,
        requestDialogSteps: [],
        requestDialogCurrentStep: {},
        requestDialogAllStepsCompleted: false,
        requestDialogClient: null,
        requestDialogService: null,
        requestDialogIsValid:false,
        requestDialogValidateGetPeritadoPending: false,
        requestDialogValidateGetPeritadoError: null,
        allStepsCompleted: false,
        updateClienteSuccess: false,
      }
    default:
      return state
  }
}
